import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Defer scroll to allow animation to start first
    // This prevents the flash of previous page content
    const timer = requestAnimationFrame(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      });
    });
    
    return () => cancelAnimationFrame(timer);
  }, [pathname]);

  return null;
}